// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page { margin: 0 }
body { margin: 0 }
.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}

/** Paper sizes **/
body.A3               .sheet { width: 297mm; height: 419mm }
body.A3.landscape     .sheet { width: 420mm; height: 296mm }
body.A4               .sheet { width: 210mm; height: 296mm }
body.A4.landscape     .sheet { width: 297mm; height: 209mm }
body.A5               .sheet { width: 148mm; height: 209mm }
body.A5.landscape     .sheet { width: 210mm; height: 147mm }
body.letter           .sheet { width: 216mm; height: 279mm }
body.letter.landscape .sheet { width: 280mm; height: 215mm }
body.legal            .sheet { width: 216mm; height: 356mm }
body.legal.landscape  .sheet { width: 357mm; height: 215mm }

/** Padding area **/
.sheet.padding-10mm { padding: 10mm }
.sheet.padding-15mm { padding: 15mm }
.sheet.padding-20mm { padding: 20mm }
.sheet.padding-25mm { padding: 25mm }

/** For screen preview **/
@media screen {
  body { background: #e0e0e0 }
  .sheet {
    background: white;
    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
    margin: 5mm auto;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
           body.A3.landscape { width: 420mm }
  body.A3, body.A4.landscape { width: 297mm }
  body.A4, body.A5.landscape { width: 210mm }
  body.A5                    { width: 148mm }
  body.letter, body.legal    { width: 216mm }
  body.letter.landscape      { width: 280mm }
  body.legal.landscape       { width: 357mm }
}`, "",{"version":3,"sources":["webpack://./src/app/components/print-entry-form/print-entry-form.component.css"],"names":[],"mappings":"AAAA,QAAQ,UAAU;AAClB,OAAO,UAAU;AACjB;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;AAC3D,+BAA+B,YAAY,EAAE,cAAc;;AAE3D,mBAAmB;AACnB,sBAAsB,cAAc;AACpC,sBAAsB,cAAc;AACpC,sBAAsB,cAAc;AACpC,sBAAsB,cAAc;;AAEpC,yBAAyB;AACzB;EACE,OAAO,oBAAoB;EAC3B;IACE,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;WACW,oBAAoB,aAAa;EAC1C,6BAA6B,aAAa;EAC1C,6BAA6B,aAAa;EAC1C,6BAA6B,aAAa;EAC1C,6BAA6B,aAAa;EAC1C,6BAA6B,aAAa;EAC1C,6BAA6B,aAAa;AAC5C","sourcesContent":["@page { margin: 0 }\nbody { margin: 0 }\n.sheet {\n  margin: 0;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  page-break-after: always;\n}\n\n/** Paper sizes **/\nbody.A3               .sheet { width: 297mm; height: 419mm }\nbody.A3.landscape     .sheet { width: 420mm; height: 296mm }\nbody.A4               .sheet { width: 210mm; height: 296mm }\nbody.A4.landscape     .sheet { width: 297mm; height: 209mm }\nbody.A5               .sheet { width: 148mm; height: 209mm }\nbody.A5.landscape     .sheet { width: 210mm; height: 147mm }\nbody.letter           .sheet { width: 216mm; height: 279mm }\nbody.letter.landscape .sheet { width: 280mm; height: 215mm }\nbody.legal            .sheet { width: 216mm; height: 356mm }\nbody.legal.landscape  .sheet { width: 357mm; height: 215mm }\n\n/** Padding area **/\n.sheet.padding-10mm { padding: 10mm }\n.sheet.padding-15mm { padding: 15mm }\n.sheet.padding-20mm { padding: 20mm }\n.sheet.padding-25mm { padding: 25mm }\n\n/** For screen preview **/\n@media screen {\n  body { background: #e0e0e0 }\n  .sheet {\n    background: white;\n    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);\n    margin: 5mm auto;\n  }\n}\n\n/** Fix for Chrome issue #273306 **/\n@media print {\n           body.A3.landscape { width: 420mm }\n  body.A3, body.A4.landscape { width: 297mm }\n  body.A4, body.A5.landscape { width: 210mm }\n  body.A5                    { width: 148mm }\n  body.letter, body.legal    { width: 216mm }\n  body.letter.landscape      { width: 280mm }\n  body.legal.landscape       { width: 357mm }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
